import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/Role";

class RoleService {
    create(data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}`, {
            data
        }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    search(returnAll = true, page = 1, showCount = 10) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/SearchAdmin`, 
            {
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": returnAll,
                    "targetPage": page,
                    "showCount": showCount
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    searchMember(returnAll = true, page = 1, showCount = 10) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/SearchMember`, 
            {
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": returnAll,
                    "targetPage": page,
                    "showCount": showCount
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    update(companyId, data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.put(`${BASIC_API}/${companyId}`, {
            data
        }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    getDetails(companyId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.get(`${BASIC_API}/${companyId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    changeIsEnabled(courseId, isEnabled, name, sort = 99999) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.put(`${BASIC_API}/${courseId}`, {
            isEnabled,
            name,
            sort
        }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    // 細節頁面的章、節拖拉排序
    batchSort(courseId, requestBody) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";
        
        return axios.post(`${BASIC_API}/DetailBatchSort/${courseId}`, 
            requestBody, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    delete(companyId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.delete(`${BASIC_API}/${companyId}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    uploadImages(formData) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/UploadHandler.ashx`,
            formData, {
                headers: {Authorization: `Bearer ${token}`}
            }
        );
    }

    submitAnswer(testQuestionId, answer, isConfident) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/SubmitAnswer.ashx`, 
            {
                testQuestionId,
                answer,
                isConfident
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    submitTest(testId) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/SubmitTestPaper.ashx`, 
            {
                testId,
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    deleteNotes(questionIds) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/DeleteNote.ashx`, 
            {
                questionIds,
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
}

const NewRoleService = new RoleService();
export default NewRoleService;